let currentDate = new Date();
export let time = currentDate.getHours() + ':' + currentDate.getMinutes();
export let date = currentDate;
